import ApiContext, { iApiContext } from 'ApiContext';
import { useContext } from 'react';

function useApiContext(): iApiContext {
  return useContext(ApiContext);
}

export default useApiContext;
